import { z } from 'zod';
import { startOfBusinessDate } from '../../dates/business-day.js';
import { isStorableCalendarDate } from '../../dates/calendar-date.js';
// date_first_ship is a timestamptz AR reads in Pacific, so a planned day is stored as the instant that Pacific day begins.
export const plannedShipDateSchema = z
    .string({
    error: (issue) => issue.input === undefined ? 'Ship date is required.' : 'Ship date must be a valid date.',
})
    .transform((value, context) => {
    if (isStorableCalendarDate(value))
        return startOfBusinessDate(value);
    context.addIssue({ code: 'custom', message: 'Ship date must be a valid date.' });
    return z.NEVER;
});
//# sourceMappingURL=ship-date-input.js.map